import React, { useEffect, useState } from "react";
import {
  Portlet,
  PortletHeader,
  PortletHeaderToolbar
} from "../../../../components/Portlet";
import CountryForm from "../components/countryForm";
import { connect } from "react-redux";
import {
  DeleteItem,
  GetItem,
  UpdateItem
} from "../../../../redux/actions/base";
import { CountryListRoute } from "../../../routesConstants";
import { useParams } from "react-router-dom";
import BlockUi from "@availity/block-ui";
import { Dropdown, Row, Col } from "react-bootstrap";
import DropdownButton from "react-bootstrap/DropdownButton";
import {Helmet} from "react-helmet";

const CountryEditPage = props => {
  const [country, setCountry] = useState(null);
  const [loader, setLoader] = useState(false);

  const { id } = useParams();
  useEffect(() => {
    if (country === null) {
      setLoader(true);
      props.GetItem("/api/locations/countries", id, res => {
        setCountry(res.data.data);
        setLoader(false);
      });
    }
  }, [country, id, props]);
  const callback = (values, cb) => {
    props.UpdateItem(
      "/api/locations/countries/" + id,
      values,
      cb,
      CountryListRoute
    );
  };
  const deleteAction = () => {
    setLoader(true);
    props.DeleteItem(
      "/api/locations/countries/" + id,
      () => {},
      CountryListRoute
    );
  };
  return (
    <>
      <Helmet>
        <title>{country?.name || 'Страна'}</title>
      </Helmet>
      <Row>
        <Col lg={6}>
          <Portlet>
            <PortletHeader
              title={"Редактирование страны"}
              toolbar={
                <PortletHeaderToolbar>
                  <BlockUi blocking={loader}>
                    <DropdownButton variant="outline-danger" title="Удалить">
                      <Dropdown.Item as="button" onClick={deleteAction}>
                        Да! Удалить
                      </Dropdown.Item>
                    </DropdownButton>
                  </BlockUi>
                </PortletHeaderToolbar>
              }
            />
            <BlockUi blocking={loader}>
              <CountryForm onSubmit={callback} data={country} />
            </BlockUi>
          </Portlet>
        </Col>
      </Row>
    </>
  );
};

export default connect(null, { GetItem, UpdateItem, DeleteItem })(
  CountryEditPage
);
